import { isTelegramEnvironment } from "@/lib/telegram";
import type { PlatformName } from "./types";

/** Shape of the global the Capacitor native shell injects. Typed locally on
 *  purpose — importing @capacitor/core here would pull Capacitor into the
 *  Telegram bundle path just to detect its absence. */
interface CapacitorGlobal {
  Capacitor?: { isNativePlatform?: () => boolean };
}

export function detectPlatformName(): PlatformName {
  if ((window as unknown as CapacitorGlobal).Capacitor?.isNativePlatform?.() === true) {
    return "ios";
  }

  // Check for Telegram environment
  if (isTelegramEnvironment()) {
    return "telegram";
  }

  // Default to web
  return "web";
}
